export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Ebook_Writing_de-DE.737ad99.vtt";